export default {
  MOBILE: 'MOBILE_RENDER_DEVICE',
  TABLET: 'TABLET_RENDER_DEVICE',
  DESKTOP: 'DESKTOP_RENDER_DEVICE'
};
